<template>
  <vs-collapse class="new_cstm_collapse_holder">
    <!-- <pre>{{ answer_list }}</pre> -->

    <vs-collapse-item v-for="(subjects, index) in answer_list" :key="index">
      <div slot="header">
        <h4>{{ subjects.subject }}</h4>
      </div>

      <vs-tabs class="cstm-card">
        <vs-tab label="Homeworks">
          <grade-assignment-modal
            :lessonAssignment="subjects.assignments.homework"
            :sectionType="2"
          />

          <vs-divider/>
          <vs-button class="block mx-auto" v-if="edit_permission" @click="saveGrade">Save Homework Grade</vs-button>
        </vs-tab>

        <vs-tab label="Exams">
          <grade-assignment-modal
            :lessonAssignment="subjects.assignments.exam"
            :sectionType="4"
          />

          <vs-divider/>
          <vs-button class="block mx-auto" v-if="edit_permission" @click="saveGrade">Save Exam Grade</vs-button>
        </vs-tab>

        <vs-tab label="Reports">
          <!-- <pre>{{ subjects.assignments.report }}</pre> -->
          <grade-assignment-modal
            :lessonAssignment="subjects.assignments.report"
            :sectionType="3"
          />

          <vs-button class="block mx-auto" v-if="edit_permission" @click="saveReport">Save Report</vs-button>
        </vs-tab>
      </vs-tabs>
    </vs-collapse-item>

    <vs-divider />
    <vs-button class="block mx-auto" v-if="edit_permission" @click="generateGradebook">Generate Gradebook</vs-button>
  </vs-collapse>
</template>

<script>
import GradeAssignmentModal from './GradeAssignmentModal.vue'
import { studentAnswersRemark, studentAnswersRemarkReport, generateStudentGradebook } from '@/api/classes'

export default {
  name: 'MarkEntry',
  props: ['class_id', 'answer_list', 'client_user_id', 'user_course_answer_master_id', 'edit_permission'],
  components: {
    GradeAssignmentModal
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    generateGradebook () {
      const client_user_id = this.client_user_id
      const class_id =  this.class_id
      const user_class_answer_master_id = this.user_course_answer_master_id

      const payload = {
        client_user_id,
        class_id,
        user_class_answer_master_id
      }

      //console.log('gradebook payload', payload)
      this.studentGradebook(payload)
    },
    async studentGradebook (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const response = await generateStudentGradebook(customer_id, payload)

        if (response.status === 201) {
          this.showSuccessMessage('Gradebook generated', 'Redirecting to gradebook...', 'success')

          setTimeout(() => {
            this.$router.push({ name: 'class_gradebook', params: { payload, class_id: this.class_id, client_user_id: this.client_user_id } })
          }, 2000)
        }
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    },
    async saveReport () {
      this.$vs.loading({
        text: 'Updating marks...'
      })

      //console.log('answer list', this.answer_list)

      const reportData = []
      let subjectIds = []

      this.answer_list.map(item => {
        item.assignments.report.map(report => {
          //console.log('rep', report)
          reportData.push(report)
          const _tempSubjectIds = Array(report.question_answers.length).fill(item.subject_id, 0)
          subjectIds.push(_tempSubjectIds)
        })
      })

      subjectIds = subjectIds.flat()

      const all_data = [...reportData]
        
      const all_qa = all_data.map(data => {
        //console.log(data)
        return data.question_answers
      }).flat()

      //console.log('all reports', all_qa)

      const all_reports = all_qa.map((ans, index) => {
        //console.log('each', ans)

        let question_answer = null

        if (ans.questions.questions_options.length > 0) {
          question_answer = ans.questions.questions_options.filter(x => { return x.id === ans.answers.assignment_question_answer_id })
        }

        if (question_answer !== null && question_answer.length > 0) {
          question_answer = question_answer[0].option_name
        } else {
          question_answer = ans.answers.short_answer
        }

        //If question is of checkbox type
        if (ans.questions.question_input_type_id === 6) {
          question_answer = ans.questions.questions_options.map((x) => {
            if (ans.answers.assignment_question_answer_id && ans.answers.assignment_question_answer_id.includes(x.id)) {
              return x.option_name
            } 
          }).filter(Boolean)
          question_answer = question_answer.join('\n')
        }

        // console.log('For subject id', subjectIds[index])

        return {
          user_class_answer_master_id: this.user_course_answer_master_id,
          assignment_builder_id: ans.questions.assignment_builder_id,
          assignment_question_id: ans.questions.id,
          question_title: ans.questions.title,
          question_answer,
          assignment_question_answer_id: ans.answers.assignment_question_answer_id,
          teacher_comment: ans.answers.teacher_comment,
          subject_id: subjectIds[index]
        }

      }).filter(element => element !== undefined)

      //console.log('ans', all_reports)

      try {
        const payload = {
          report_comments: all_reports
        }

        const customer_id = localStorage.getItem('customer_id')
        const response = await studentAnswersRemarkReport(customer_id, payload)

        if (response.status === 202) {
          this.showSuccessMessage('Success', 'Report saved successfully', 'success')
        }
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')
      } finally {
        this.$vs.loading.close()
      }
    },
    async saveGrade () {
      this.$vs.loading({
        text: 'Updating marks...'
      })
        
      //console.log('answer list', this.answer_list)
      const homeworkData = []
      const examData = []
      const reportData = []

      this.answer_list.map(item => {
        //console.log('item', item)
        item.assignments.homework.map(hw => {
          //console.log('hw', hw)
          homeworkData.push(hw)
        })

        item.assignments.exam.map(exam => {
          //console.log('ex', exam)
          examData.push(exam)
        })

        item.assignments.report.map(report => {
          //console.log('rep', report)
          reportData.push(report)
        })
      })

      const all_data = [...homeworkData, ...examData]
      //console.log('all data', all_data)

      const all_qa = all_data.map(data => {
        // console.log('each data', data)
        return data.question_answers.map(item => {
          return { ...item.answers, assignment_type_id: data.assignment_type_id }
        })
      }).flat()

      // console.log('all qa', all_qa)

      const all_answers = all_qa.map(ans => {
        //console.log(ans.answers.user_class_answer_master_id !== undefined)
        if (ans.user_class_answer_master_id !== undefined) {
          //console.log(ans.answers)
          return {
            mark: ans.mark,
            teacher_comment: ans.teacher_comment,
            assignment_type_id: ans.assignment_type_id,
            student_answer_id: ans.id
          }
        }
      }).filter(element => element !== undefined)

      // console.log('ans', all_answers)
      
      try {
        const payload = {
          marks: all_answers
        }

        const customer_id = localStorage.getItem('customer_id')
        const response = await studentAnswersRemark(customer_id, payload)

        if (response.status === 202) {
          this.showSuccessMessage('Success', 'Marks updated successfully', 'success')
        }
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>